// WebTrends SmartSource Data Collector Tag v10.4.1
// Copyright (c) 2014 Webtrends Inc.  All rights reserved.
// Tag Builder Version: 4.1.3.2
// Created: 2014.03.27
var WebtrendsDcs;
window.webtrendsAsyncInit=function(){
    WebtrendsDcs = new Webtrends.dcs().init({
        dcsid:"dcs222l9nwift8e4wcqk9bgst_4i5i",
        domain:"statse.webtrendslive.com",
        timezone:-5,
        i18n:true,
        offsite:true,
        download:true,
        downloadtypes:"dbf,xls,doc,pdf,txt,csv,zip,docx,xlsx,rar,gzip,kmz",
        anchor:true,
        javascript: true,
        onsitedoms:".hrsa.gov",
        fpcdom:".hrsa.gov",
        plugins:{
            facebook:{src:"//s.webtrends.com/js/webtrends.fb.js"},
            yt:{src:"//s.webtrends.com/js/webtrends.yt.js"}
        }
    }).addSelector('a.badge-pdf',
      {
          transform: function (dcsObject, multiTrackObject) {
              var e = multiTrackObject.element || {};
              var hn = e.hostname ? (e.hostname.split(":")[0]) : "";
              var pr = e.protocol || "";
              var qry = e.search ? e.search.substring(e.search.indexOf("?") + 1, e.search.length) : "";
              var pth = e.pathname ? ((e.pathname.indexOf("/") != 0) ? "/" + e.pathname : e.pathname) : "/";
              multiTrackObject.argsa.push(
                      "DCS.dcssip", hn,
                      "DCS.dcsuri", pth,
                      "DCS.dcsqry", qry,
                      "DCS.dcsref", window.location,
                      "WT.ti", "Download: PDF", // "WT.ti", "Download:" + hn + pth + (qry.length ? ("?" + qry) : ""),
                      "WT.dl", "20"
              );
          }
      }).addSelector('a.badge-xlxs',
      {
          transform: function (dcsObject, multiTrackObject) {
              var e = multiTrackObject.element || {};
              var hn = e.hostname ? (e.hostname.split(":")[0]) : "";
              var pr = e.protocol || "";
              var qry = e.search ? e.search.substring(e.search.indexOf("?") + 1, e.search.length) : "";
              var pth = e.pathname ? ((e.pathname.indexOf("/") != 0) ? "/" + e.pathname : e.pathname) : "/";
              multiTrackObject.argsa.push(
                      "DCS.dcssip", hn,
                      "DCS.dcsuri", pth,
                      "DCS.dcsqry", qry,
                      "DCS.dcsref", window.location,
                      "WT.ti", "Download: XLXS",  // "WT.ti", "Download:" + hn + pth + (qry.length ? ("?" + qry) : ""),     
                      "WT.dl", "20"
              );
          }
      })
        .track();
};
(function(){
    var s = document.createElement("script"); s.async = true; s.src = "//s.webtrends.com/js/webtrends.js";    
    var s2=document.getElementsByTagName("script")[0]; s2.parentNode.insertBefore(s,s2);
}());
